// extracted by mini-css-extract-plugin
export default {"Container":"likedProducts_Container__Dxi4f"};